import { StaticAnnouncement } from './static-announcement'
import { Icons } from '@/theme/Images'
import PlaidRecurringModal from '../pages/plaid-recurring-page/plaid-recuring-modal'

const PlaidNoLinkBanner = () => {
  return (
    <StaticAnnouncement
      startIcon={Icons.grayNotificationIcon}
      text="Your vehicle lease or loan payment account is not connected. Without this, you will be ineligible to earn rewards in this category and won't be able to take full advantage of our benefits."
      action={<PlaidRecurringModal />}
    />
  )
}

export default PlaidNoLinkBanner
